import * as z from 'zod';

import { validaNomeCompleto } from '../../../../utils/ValidaNome';
import {
  parseBrDate,
  validateBirthDate,
  validateCPF,
} from '../../../../utils/validations';

function getAgeFromBrDate(value?: string): number | null {
  if (!value || !/^(\d{2})\/(\d{2})\/(\d{4})$/.test(value)) {
    return null;
  }

  const birthDate = parseBrDate(value);

  if (!birthDate) {
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const hasNotHadBirthdayThisYear =
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate());

  if (hasNotHadBirthdayThisYear) {
    age -= 1;
  }

  return age;
}

const optionalFullName = z.optional(
  z
    .string()
    .min(1, { message: 'Campo obrigatorio' })
    .refine(val => validaNomeCompleto(val), {
      message: 'Digite o nome completo sem abreviacoes (ex: Joao da Silva)',
    }),
);

export const newDependentsSchema = z
  .object({
    name: optionalFullName,
    birthDate: z
      .string()
      .min(1, { message: 'Campo obrigatorio' })
      .regex(/^(\d{2})\/(\d{2})\/(\d{4})$/, {
        message: 'Formato invalido (use DD/MM/AAAA)',
      })
      .refine(validateBirthDate, { message: 'Data de nascimento invalida' }),
    civilStatus: z.optional(
      z.string().min(1, { message: 'Campo obrigatorio' }),
    ),
    gender: z.optional(z.string().min(1, { message: 'Campo obrigatorio' })),
    parentage: z.optional(z.string().min(1, { message: 'Campo obrigatorio' })),
    cpf: z.optional(
      z.string().refine(val => !val || validateCPF(val.replace(/\D/g, '')), {
        message: 'CPF invalido',
      }),
    ),
    mothersName: optionalFullName,
    cns: z.optional(z.string()),
    plano: z.optional(z.string()),
    plano_vl: z.optional(z.string()),
  })
  .superRefine((dependent, ctx) => {
    const age = getAgeFromBrDate(dependent.birthDate);
    const cpf = dependent.cpf?.replace(/\D/g, '') || '';

    if (age !== null && age >= 16 && !cpf) {
      ctx.addIssue({
        code: 'custom',
        message: 'CPF obrigatorio para dependente com 16 anos ou mais',
        path: ['cpf'],
      });
    }
  });
